import React from 'react';
import autobind from 'autobind-decorator';
import { observer, inject } from 'mobx-react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { Modal } from 'client/shared/components';

import CheckoutForm from './checkout-form';

const stripePromise = loadStripe('pk_test_Bdol6G0NPRGEw6h9fjQzctOw');

const SUBSCRIBE_DISCLAIMER = (
	<p className="margin-bottom-0">
		Your subscription will automatically renew every year at the current subscription price.
		You may cancel your subscription at any time. If you cancel, you will no longer be able
		to download songs from this catalog, and will have to subscribe again to regain access.
	</p>
);

@inject('membersBFFStore', 'userStore', 'formStore')
@observer
class SubscribeModal extends React.Component {
	state = {
		modalOpen: false
	}

	render () {
		if (!this.props.artist) return null;

		const {
			modalContentLabel = `Subscribe to ${ this.props.artist.name }`,
			menuMode = false,
			artist
		} = this.props;

		return (
			<div className="subscribe">
				<Modal
					isOpen={ this.state.modalOpen }
					onClose={ this.handleCloseModal }
					size="md"
					title={ `Subscribe to ${ artist.name }` }
					contentLabel={ modalContentLabel }
					footer={ SUBSCRIBE_DISCLAIMER }
					dataTa="subscribe-modal"
					closeButtonDataTa="closeAddMemberModalBtn"
				>
					{ this.renderModalContent() }
				</Modal>

				{ !menuMode && (
					<button
						data-ta="subscribe-button"
						className="add-button button margin-top-1"
						onClick={ this.handleOpenModal }
					>
						Subscribe
					</button>
				) }

				{ menuMode && this.renderListButton({
					icon: '',
					label: 'Subscribe',
					ariaLabel: 'subscribe',
					onClick: this.handleOpenModal
				}) }
			</div>
		);
	}

	renderModalContent () {
		const { membersBFFStore, userStore, artist } = this.props;

		if (userStore.isLoading) {
			return (
				<div
					className="mzd-subscribe-modal-body-loading"
					style={ {
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						minHeight: '10rem',
					} }
				>
					<div className="loading-spinner large">
						<div />
					</div>
				</div>
			);
		}

		return (
			<Elements stripe={ stripePromise }>
				<CheckoutForm
					handleCloseModal={ this.handleCloseModal }
					artist={ artist }
					membersBFFStore={ membersBFFStore }
				/>
			</Elements>
		);
	}

	@autobind
	renderListButton ({
		icon,
		position,
		onClick,
		label,
		className = '',
		ariaLabel,
		attrs = {}
	}) {
		return (
			<div key={ position }>
				<button
					aria-label={ ariaLabel }
					{ ...attrs }
					onClick={ onClick }
					className={ `button tertiary clear margin-bottom-0 ${ className }` }
				>
					<span className={ `${ icon } icon` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind
	handleOpenModal () {
		this.props.membersBFFStore.resetSubscribeModalState();
		this.setState({ modalOpen: true });
	}

	@autobind
	handleCloseModal () {
		this.props.membersBFFStore.resetSubscribeModalState();
		this.setState({ modalOpen: false });
		void this.props.userStore.fetchProfile({ silent: true });
	}

	@autobind
	getModalState () {
		return this.state.modalOpen;
	}
}

export default SubscribeModal;
